import { bignumber, add, subtract, divide, multiply, all, create } from 'mathjs'
const config = {
  epsilon: 1e-12,
  matrix: 'Matrix',
  number: 'BigNumber', // 可选值：number BigNumber
  precision: 64,
  predictable: false,
  randomSeed: null
}
export const math = create(all, config)
export default {
  // 加
  add(num1, num2) {
    return add(bignumber(num1), bignumber(num2))
  },
  // 减
  subtract(num1, num2) {
    return subtract(bignumber(num1), bignumber(num2))
  },
  // 乘
  multiply(num1, num2) {
    return multiply(bignumber(num1), bignumber(num2))
  },
  // 除
  divide(num1, num2) {
    return divide(bignumber(num1), bignumber(num2))
  }
}
